import { render, staticRenderFns } from "./chooseGoodsDialog.vue?vue&type=template&id=694ea653&scoped=true"
import script from "./chooseGoodsDialog.vue?vue&type=script&lang=js"
export * from "./chooseGoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseGoodsDialog.vue?vue&type=style&index=0&id=694ea653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694ea653",
  null
  
)

export default component.exports